import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=24caa3fe&scoped=true"
import script from "./UserNav.vue?vue&type=script&lang=js"
export * from "./UserNav.vue?vue&type=script&lang=js"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=24caa3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24caa3fe",
  null
  
)

export default component.exports